import logo from './logo.svg';
import './App.css';
import { memo, useEffect, useMemo, useRef, useState } from 'react';
import {Card, CardFooter, Image, Button, user} from "@nextui-org/react";
import {Input} from "@nextui-org/react";
import { SearchIcon } from './searchIcon';
import {ScrollShadow} from "@nextui-org/react";
import {Badge, Avatar} from "@nextui-org/react";
import {Select, SelectItem, Textarea} from "@nextui-org/react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, useDisclosure} from "@nextui-org/react";
import {Spinner} from "@nextui-org/react";
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import PocketBase from 'pocketbase';
import { ApproveIcon, RefuseIcon } from './approve';
import useHasAdBlock from './adblock';
import { home_data } from './homedata';


//const pb = new PocketBase('https://api.abetterbunkralbums.xyz');
const pb = new PocketBase('https://db.abetterbunkralbums.xyz');


const addScripts = async (id) => {
  const mainScript = document.createElement('script');
  mainScript.src = '';
  mainScript.async = true;
  mainScript['data-cfasync'] = 'false';
  document.body.appendChild(mainScript);

  // Ajout du script de publicité spécifique
  const adScript = document.createElement('script');
  adScript.type = 'text/javascript';
  adScript['data-cfasync'] = 'false';
  adScript.async = true;
  adScript['data-ad-script'] = 'true';  // Attribut personnalisé pour identifier le script de publicité
  adScript.innerHTML = `(adsbyjuicy = window.adsbyjuicy || []).push({'adzone': ${id}});`;
  document.body.appendChild(adScript);

  let currentUuid = Cookies.get('uuid');
  if (!currentUuid) {
    currentUuid = uuidv4();
    Cookies.set('uuid', currentUuid, { expires: 365 });
    //const record = await pb.collection('logs').create({"action": "new_user", "value": currentUuid,"uuid": currentUuid,"device": "na"});
  }
  
};

const AdComponent = memo(({search}) => {
  const [zIndex, setIndex] = useState(10000)
  const ids = [1054421, 1054418, 1054419, 1054420, 1054238];
  const [id, set_id] = useState(ids[Math.floor(Math.random() * ids.length)])
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const initialdraw = useRef(false);


  useEffect(() => {
    if(initialdraw.current == false && zIndex == 10000){
      initialdraw.current = true
      addScripts(id)
    }
  }, [zIndex]);

  useEffect(()=>{
    let timeoutId; // Pour stocker l'identifiant du timeout

    function handleWindowBlur() {
      timeoutId = setTimeout(() => {
        const focusedElement = document.activeElement;
        if(focusedElement.src?.includes("jads")){
          let currentUuid = Cookies.get('uuid');
          const data = {
            "uuid": currentUuid,
            "device": detectDevice(),
            "pub_id": id,
            "action": "click"
          };
          //pb.collection('impression').create(data);
          setIndex(-1)
        }
      }, 500);
    }

    const updatePosition = (e) => {
      setPosition({
        x: e.clientX - 80,
        y: e.clientY - 80
      });
    };


    window.addEventListener('blur', handleWindowBlur);
    document.addEventListener('mousemove', updatePosition);
    return () => {
      document.removeEventListener('mousemove', updatePosition);
      window.removeEventListener('blur', handleWindowBlur);
      clearTimeout(timeoutId);
    };
  }, [zIndex])

  return (
    <div
      key={zIndex}
      style={{
        position: 'absolute',
        top: `10px`,
        left: `10px`,
        justifyContent: 'center',
        opacity: 1,
        zIndex: zIndex
      }}
    >
      <span style={{ position: 'absolute', zIndex: 100000, color: 'violet' , bottom:0, left:0}}>{id}</span>
      <ins id={id} data-width="908" data-height="270"></ins>
    </div>
  );
}, (prevProps, nextProps) => {
  return prevProps.search === nextProps.search;
});

function prioritizeItems(items, category) {
  const itemsCopy = [...items];

  itemsCopy.sort((a, b) => {
    if (a.type === category && b.type !== category) {
      return -1;
    } else if (a.type !== category && b.type === category) {
      return 1;
    } else {
      return 0;
    }
  });

  return itemsCopy;
}

const openNewTab = (url) => {
  add_logs("onclick", url)
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

const Link_comp = memo((props) => {
  let color = "#EDEDED"
  if(props.data.link.includes("gofile"))
    color = "#F1BF46"
  if(props.data.link.includes("saint2"))
    color = "#A63835"
  if(props.data.link.includes("bunkr"))
    color = "#2E5F8E"
  if(props.data.link.includes("onlyfans"))
    color = "#0188ca"
  if(props.data.link.includes("chaturbate.com"))
    color = "#ed8c2f"
  return(
    <div onClick={()=>{openNewTab(props.data.link)}} style={{width:170, height:170, backgroundColor:color+"44", justifyContent:"center", alignItems:"center", borderRadius:8, border:"1px solid "+color, cursor:"pointer", flexDirection:"column", gap:10}}>
      <span style={{textAlign:"center", lineHeight:1.1, fontSize:12}}>Archive<br/>{props.data.link.slice(0,20)}</span>
      <span style={{fontSize:10,textWrap:"wrap", wordWrap:"break-word", maxWidth:150, textAlign:"center", lineHeight:1}}>{props.data.link}</span>
    </div>
  )
})

const Premium_item = (props) => {
  return(
    <div style={{width:170*2, height:170*2}}>
      <iframe src={props.item.link} height={170*2} width={170*2} style={{border:"none"}} loading='lazy' allow='fullscreen'/>
    </div>
  )
}


const Item_comp = memo(function Item_comp(props) {
  const item = props.item
  const filetype = item.type
  const display_normal = []
  return(
    <div>
      <div style={{cursor:"pointer"}} onClick={()=>{openNewTab(item.link)}}>
        <Badge style={{zIndex:1}} content={filetype} color={filetype=="image"?"primary":filetype=="video"?"secondary":"warning"} placement="top-right">
          {!item.name.includes("saint2")&&!item.name.includes("/v/")&&!item.name.includes("/e/")&&<div>
            <div style={{backgroundImage:"url('"+item.image+"')", backgroundRepeat:"no-repeat", backgroundSize:"cover" , width:170, height:170}}/>
            <div style={{position:"absolute", bottom:5, left:5, right:5, zIndex:1, backgroundColor:"#ffffffaa", borderRadius:10, justifyContent:"center", flexDirection:"column"}}>
              {item.size!=0&&<span style={{fontSize:10, wordWrap:"break-word", maxWidth:"100%", color:"black", textAlign:"center", padding:"2px 10px"}}>{item.name.slice(0, 20)}</span>}
              {item.size!=0&&<span style={{fontSize:10, textAlign:"center", fontWeight:"700", color:"black", letterSpacing:-1}}>{item.size}</span>}
            </div>
          </div>}
          {item.name.includes("saint2")&&<iframe src={props.item.link} height={170*2} width={170*2} style={{border:"none"}} loading='lazy' allow='fullscreen'/>}
          {item.name.includes("/v/")&&<iframe src={props.item.link.replace("/v/", "/embed/")} height={170*2} width={170*2} style={{border:"none"}} loading='lazy' allow='fullscreen'/>}
          {item.name.includes("/e/")&&<iframe src={props.item.link} height={170*2} width={170*2} style={{border:"none"}} loading='lazy' allow='fullscreen'/>}
        </Badge>
      </div>
    </div>
  )
});

function SearchBar(props){
  const handleKey = (e)=> {
    if(e.key == "Enter"){
      props.onSearch()
    }
  }
  return (
    <Input
      onKeyDown={handleKey}
      label="Search inside bunkr archive ;)"
      isClearable
      radius="lg"
      classNames={{
        label: "text-black/50 dark:text-white/90",
        input: [
          "bg-transparent",
          "text-black/90 dark:text-white/90",
          "placeholder:text-default-700/50 dark:placeholder:text-white/60",
        ],
        innerWrapper: "bg-transparent",
        inputWrapper: [
          "shadow-xl",
          "bg-default-200/50",
          "dark:bg-default/60",
          "backdrop-blur-xl",
          "backdrop-saturate-200",
          "hover:bg-default-200/70",
          "dark:hover:bg-default/70",
          "group-data-[focused=true]:bg-default-200/50",
          "dark:group-data-[focused=true]:bg-default/60",
          "!cursor-text",
        ],
      }}
      placeholder="Type to search..."
      startContent={
        <SearchIcon className="text-black/50 mb-0.5 dark:text-white/90 text-slate-400 pointer-events-none flex-shrink-0" />
      }
      value={props.value}
      onValueChange={props.onChange}
    />
  );
}
function detectDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);
  return isMobile ? "Mobile/Tablet" : "Desktop";
}

const add_logs = async (action, value) =>{
  pb.autoCancellation(false)
  let currentUuid = Cookies.get('uuid');
  if (!currentUuid) {
    currentUuid = uuidv4();
    Cookies.set('uuid', currentUuid, { expires: 365 });
    const record = await pb.collection('logs').create({"action": "new_user", "value": currentUuid,"uuid": currentUuid,"device": detectDevice(), "website":window.location.hostname});
  }
  const record = await pb.collection('logs').create({"action": action, "value": value,"uuid": currentUuid,"device": detectDevice(), "website":window.location.hostname});
} 

function sortItemsByDate(items) {
  items.sort((a, b) => a.date - b.date);
  return items;
}
function sortItemsByDateDescending(items) {
  items.sort((a, b) => b.date - a.date);
  return items;
}



const perform_premium_search = async (term) => {
  try {
    const response = await fetch('https://api.abetterbunkralbums.xyz/search_api/'+term);
    if (!response.ok) {
      throw new Error(`Erreur HTTP: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erreur lors du fetch:', error);
    return []
  }
}
const perform_refresh = (term) => {
  add_logs("search_from_bar", term)
  window.history.pushState("", "", "/search/"+term);
  window.location.reload(true);
}

function App() {
  const [items, set_items] = useState([])
  const [search, set_search] = useState("")
  const [is_search, set_is_search] = useState(false)
  const [is_empty, set_is_empty] = useState(false)
  const [sugg, set_sugg] = useState("")
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [has_alink, set_hasalink] = useState(true)
  const categorize_by = useRef("")
  const scroll_div = useRef(null)
  const has_init_link = useRef(false)
  const hasAdblock = useHasAdBlock();
  const [max_slice, set_max_slice] = useState(30)
  const [should_charge, set_should_charge] = useState(false)

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  
  const perform_search = async (term) => {
    set_items([])
    set_is_search(true)
    set_is_empty(false)
    set_max_slice(30)
    set_should_charge(false)
    window.history.pushState("", "", "/search/"+term);
    
    let premium = []
    try{
      premium = await perform_premium_search(term)
      add_logs("search_for", term+"/"+premium.length.toString())
      if(premium.length == 0){
        set_is_empty(true)
      }
      set_items(sortItemsByDateDescending(premium))
    }catch(e){
      console.log(e)
      set_items([])
      set_is_empty(true)
    }
    set_is_search(false)
    set_should_charge(true)
}

  const send_sugg = async () => {
    fetch("https://abetterbunkralbums.xyz/suggest/"+sugg)
    set_sugg("")
    
  }

  useEffect(()=>{
    const splitted_search = window.location.href.split("/search/")
    if(has_init_link.current == false){
      has_init_link.current = true
      if(splitted_search.length > 1){
        if(search != decodeURIComponent(splitted_search[1])){
          perform_search(decodeURIComponent(splitted_search[1]))
          set_search(decodeURIComponent(splitted_search[1]))
        }else{
          set_hasalink(false)
        }
      }else{
        set_hasalink(false)
      }
    }
  }, [])


  const sort_by = (items, term) => {
    if(categorize_by.current == term){
      return items
    }else{
      add_logs("sorted_by", term)
      categorize_by.current = term
      set_max_slice(30)
      if (scroll_div.current)
        scroll_div.current.scrollTop = 0;

      if(term == "old"){
        return sortItemsByDate(items)
      }
      if(term == "new"){
        return sortItemsByDateDescending(items)
      }
      if(term == "image" || term == "video"){
        return prioritizeItems(items, term)
      }
      if(term == ""){
        return items
      }
    }
  }
  const should_charge_more_item = (e) => {
    if(items.length > 10){
      if(e.target.scrollTop+e.target.clientHeight > e.target.scrollHeight-100){
        set_max_slice(max_slice=>max_slice+30)
      }
    }
  }
  return (
    <div ref={scroll_div} onScroll={should_charge_more_item} style={{flex:1, flexDirection:"column", padding:"90px 0", overflowY:"auto", overflowX:"hidden", height:"100vh", width:"100vw"}}>
      {max_slice>30&&<div style={{position:"absolute", right:10, bottom:10, zIndex:1000000, left:10, justifyContent:"center"}}>
        <div onClick={()=>{scroll_div.current.scrollTo({top: 0, behavior: "smooth"})}} style={{backgroundColor:"#232527", padding:"10px 20px", borderRadius:100, cursor:"pointer"}}>
          <span style={{fontSize:20}}>Back to Top</span>
        </div>
      </div>}
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Any questions ?</ModalHeader>
              <ModalBody>
                <p>Welcome! This is a small tool I originally created for my personal use. It addresses the UX issue with Bunkr search. I thought if it was relevant for me, it might be for you too. My goal isn't to steal traffic from Bunkr or take advantage of their hosting; on the contrary, I aim to better redirect their traffic. I will update the tool based on your suggestions/requests that you can leave below in the mini form. Enjoy using the tool.</p>
                <Textarea
                  onValueChange={(e)=>{set_sugg(e)}}
                  label="Suggestion ?"
                  placeholder="The better you describe it, the more likely I am to implement it."
                  value={sugg}
                />
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>Close</Button>
                <Button color="primary" onPress={()=>{send_sugg();onClose()}}>Send</Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
      
      <div style={{alignSelf:"center", flexDirection:"column", paddingTop:30, alignItems:"center", paddingBottom:20}}>
      {items.length==0&& <h1 style={{fontSize:60, fontWeight:"700", letterSpacing:-1.2, wordSpacing:-2, color:"white", textAlign:"center", wordWrap:"normal", lineHeight:"60px"}}>betterbunkr.cc</h1>}
      {items.length!=0&& <h1 style={{fontSize:30, fontWeight:"700", letterSpacing:-1.2, wordSpacing:-2, color:"white", textAlign:"center", wordWrap:"normal", lineHeight:"60px"}}>betterbunkr.cc</h1>}
        <h2 style={{padding:"0px 10px", textAlign:"center", fontSize:15}}>Search leak archive in bunkr-albums.io (bunkralbums)</h2>
      </div>
      <div style={{flex:1, justifyContent:"center", flexDirection:"row"}}>
        <div style={{flexDirection:"column", minWidth:345 ,width:"60%",maxWidth:720, margin:"10px 10px", flex:1}}>
          <div style={{margin:"0px 10px", justifyContent:"flex-end"}}>
            <Button variant="light" size="sm" onPress={onOpen}>any questions ?</Button>
          </div>
          <div style={{margin:"0px 10px", flexDirection:"row", gap:5}}>
            <div style={{flex:1, flexDirection:"column"}}>
              <SearchBar onSearch={()=>{perform_refresh(search)}} onChange={(e)=>{set_search(e)}} value={search}/>
            </div>
            {items.length>0&&<div style={{}}>
              <Select onSelectionChange={(e)=>{set_items(items=>[...sort_by(items, e.currentKey)])}} label="Sort by" placeholder="Select an extension" style={{width:120}}>{["video", "image", "new", "old"].map((cat)=>(<SelectItem key={cat} value={cat}>{cat}</SelectItem>))}</Select>
            </div>}
          </div>
          <span style={{fontSize:12, letterSpacing:-0.3, padding:"1px 5px", margin:"5px 6px", color:"#f89c22"}}>Press the return button on mobile or enter key on pc to perform the search.</span>
          <div style={{flex:1, minHeight:100, flexDirection:"column"}}>
            
            {false&&!has_alink&&<div hideScrollBar style={{width:"100%", flexDirection:"row", flexWrap:"wrap", justifyContent:"center",gap:5}}>
              {home_data.map((item, index)=>{
                return(
                  <div key={index} onClick={()=>{openNewTab("https://abetterbunkralbums.xyz/search/"+item[0])}} style={{position:"relative",width:200, height:170, justifyContent:"flex-end", alignItems:"center", borderRadius:8, border:"1px solid red", cursor:"pointer", flexDirection:"column", gap:10}}>
                    <img alt={item[0]} style={{position:"absolute", top:0, left:0, borderRadius:8}} src={item[1]} width={200} height={170}/>
                    <span style={{textAlign:"center", lineHeight:1.1, fontSize:14, fontWeight:"700", zIndex:1000, paddingBottom:10}}>{item[0]}</span>
                  </div>
                )
              })}
            </div>}
            {!is_search&&!is_empty&&<div hideScrollBar style={{width:"100%", flexDirection:"row", flexWrap:"wrap",justifyContent:"center",gap:5}}>
              {
                items.slice(0, max_slice).map((item, index)=>{
                  if(item.type == "link" && !item.link.includes(".jpg") ){
                    return(<Link_comp data={item}/>)
                  }else{
                    return(<Item_comp has_adblock={false} key={index} item={item}/>)
                  }
                })
              }
            </div>}
            {is_search&&<div style={{flex:1, justifyContent:"center", alignItems:"center", flexDirection:"column"}}>
              <Spinner />
            </div>}
            
            {is_empty&&<div style={{flex:1, justifyContent:"center", alignItems:"center"}}>
              <span style={{color:"white", textAlign:"center", opacity:"0.4"}}>We are in the process of merging our database. It is possible that more results will appear later.</span>
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
